import './ErrorBoundary.scss';

import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  // Текст для конкретного блока отчёта, если дефолтный слишком общий.
  fallbackText?: string;
}

interface State {
  hasError: boolean;
}

// Общий ErrorBoundary: перехватывает падение дочернего поддерева при рендере
// и показывает нейтральный фолбэк вместо белого экрана всей страницы.
// componentDidCatch/getDerivedStateFromError ловят только ошибки рендера
// (не обработчики событий, не асинхронный код) — этого достаточно для
// защиты отчётных блоков (Spider, Circles и т.п.) друг от друга.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary поймал ошибку рендера:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='errorBoundaryFallback' data-cy='errorBoundaryFallback'>
          {this.props.fallbackText || 'Не удалось отобразить этот блок'}
        </div>
      );
    }

    return this.props.children;
  }
}
